// special with icon assets
const iconPublicAssets = {
  PDF_ICON: '',
};

const docPublicAssets = {
  PDF_ICON: '',
};

const imagePublicAssets = {
  NOLIMIT_LOGO: '/png/logo-nolimit.png',
};

const videoPublicAssets = {
  VIDEO_ICON: '',
};

const audioPublicAssets = {
  AUDIO_ICON: '',
};

export const publicAssets = {
  ...iconPublicAssets,
  ...docPublicAssets,
  ...imagePublicAssets,
  ...videoPublicAssets,
  ...audioPublicAssets,
};
